var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M14.667 25.333c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M28 28l-5.8-5.8"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--accentGreen)",
    style: {
      fill: "var(--accentGreen)"
    },
    d: "M8.727 0h14.545c4.82 0 8.727 3.907 8.727 8.727v14.545c0 4.82-3.907 8.727-8.727 8.727h-14.545c-4.82 0-8.727-3.907-8.727-8.727v-14.545c0-4.82 3.907-8.727 8.727-8.727z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--light)",
    style: {
      stroke: "var(--light)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.4545,
    d: "M7.273 7.347v3.967c0 1.132 0.495 2.135 1.26 2.784 0.375 0.317 0.622 0.746 0.622 1.222v6.62c0 0.736 0.633 1.333 1.412 1.333s1.412-0.597 1.412-1.333v-6.621c0-0.475 0.247-0.903 0.622-1.221 0.766-0.649 1.26-1.651 1.26-2.784v0M10.567 11.717v-4.444M23.273 8.207c0-0.49-0.422-0.889-0.941-0.889h-0.941c-1.56 0-2.824 1.194-2.824 2.667v5.333c0 1.159 0.788 2.136 1.882 2.503v4.118c0 0.735 0.633 1.333 1.412 1.333s1.411-0.598 1.411-1.334v-13.732z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-lock",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M21.76 14.72v-3.84c0-3.535-2.865-6.4-6.4-6.4s-6.4 2.865-6.4 6.4v0 3.84M9.984 27.52h10.752c2.15 0 3.226 0 4.047-0.419 0.726-0.375 1.303-0.952 1.668-1.657l0.010-0.021c0.419-0.822 0.419-1.897 0.419-4.047v-0.512c0-2.15 0-3.226-0.419-4.047-0.375-0.726-0.952-1.303-1.657-1.668l-0.021-0.010c-0.822-0.419-1.897-0.419-4.047-0.419h-10.752c-2.15 0-3.226 0-4.047 0.419-0.726 0.375-1.303 0.952-1.668 1.657l-0.010 0.021c-0.419 0.822-0.419 1.897-0.419 4.047v0.512c0 2.15 0 3.226 0.419 4.047 0.375 0.726 0.952 1.303 1.657 1.668l0.021 0.010c0.822 0.419 1.897 0.419 4.047 0.419z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mail",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M2.56 9.6l10.451 7.315c0.846 0.593 1.27 0.89 1.729 1.004 0.186 0.048 0.4 0.076 0.62 0.076s0.434-0.028 0.637-0.080l-0.018 0.004c0.461-0.115 0.883-0.41 1.729-1.004l10.451-7.315M8.704 26.24h13.312c2.15 0 3.226 0 4.047-0.419 0.726-0.375 1.303-0.952 1.668-1.657l0.010-0.021c0.419-0.822 0.419-1.897 0.419-4.047v-8.192c0-2.15 0-3.226-0.419-4.047-0.375-0.726-0.952-1.303-1.657-1.668l-0.021-0.010c-0.822-0.419-1.897-0.419-4.047-0.419h-13.312c-2.15 0-3.226 0-4.047 0.419-0.726 0.375-1.303 0.952-1.668 1.657l-0.010 0.021c-0.419 0.822-0.419 1.897-0.419 4.047v8.192c0 2.15 0 3.226 0.419 4.047 0.375 0.726 0.952 1.303 1.657 1.668l0.021 0.010c0.822 0.419 1.897 0.419 4.047 0.419z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 31 32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.56,
    d: "M25.6 27.52c0-1.787 0-2.679-0.22-3.406-0.508-1.64-1.774-2.905-3.378-3.404l-0.036-0.010c-0.727-0.22-1.619-0.22-3.406-0.22h-6.4c-1.787 0-2.679 0-3.406 0.22-1.64 0.508-2.905 1.774-3.404 3.378l-0.010 0.036c-0.22 0.727-0.22 1.619-0.22 3.406M21.12 10.24c0 3.181-2.579 5.76-5.76 5.76s-5.76-2.579-5.76-5.76v0c0-3.181 2.579-5.76 5.76-5.76s5.76 2.579 5.76 5.76v0z"
  })), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--error)",
    d: "M0 16c0-8.838 7.162-16 16-16s16 7.162 16 16c0 8.837-7.163 16-16 16s-16-7.163-16-16zM10.938 13.006l2.944 2.938-2.944 2.994c-0.581 0.588-0.581 1.538 0 2.069 0.588 0.637 1.537 0.637 2.069 0l2.938-2.888 2.994 2.888c0.588 0.637 1.538 0.637 2.069 0 0.637-0.531 0.637-1.481 0-2.069l-2.888-2.994 2.888-2.938c0.637-0.531 0.637-1.481 0-2.069-0.531-0.581-1.481-0.581-2.069 0l-2.994 2.944-2.938-2.944c-0.531-0.581-1.481-0.581-2.069 0-0.581 0.588-0.581 1.537 0 2.069z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-success",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--success)",
    d: "M0 16c0-8.838 7.162-16 16-16s16 7.162 16 16c0 8.837-7.163 16-16 16s-16-7.163-16-16zM23.237 13.238c0.681-0.681 0.681-1.794 0-2.475s-1.794-0.681-2.475 0l-6.763 6.762-2.763-2.762c-0.681-0.681-1.794-0.681-2.475 0s-0.681 1.794 0 2.475l4 4c0.681 0.681 1.794 0.681 2.475 0l8-8z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--warning)",
    d: "M16 0c-8.838 0-16 7.162-16 16s7.162 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM14.5 9.5c0-0.825 0.675-1.5 1.5-1.5s1.5 0.672 1.5 1.5v8c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.669-1.5-1.5v-8zM16 25c-1.085 0-1.965-0.88-1.965-1.965s0.879-1.965 1.965-1.965c1.086 0 1.965 0.88 1.965 1.965-0.002 1.084-0.877 1.965-1.965 1.965z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.b993ae240e786f68124d13d971cb38bd.svg";
export { ForwardRef as ReactComponent };